var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2490 2500",
    style: {
      enableBackground: "new 0 0 2490 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#0CB2DA;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,183.4C0,84.9,82.4,5,184,5H2306c101.6,0,184,79.9,184,178.4v2133.3c0,98.5-82.4,178.3-184,178.3H184 c-101.6,0-184-79.8-184-178.3V183.4L0,183.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M756.7,2088.8v-1121H384.1v1121H756.7L756.7,2088.8z M570.5,814.8c129.9,0,210.8-86.1,210.8-193.7 c-2.4-110-80.9-193.7-208.3-193.7c-127.5,0-210.8,83.7-210.8,193.7c0,107.6,80.8,193.7,205.9,193.7L570.5,814.8L570.5,814.8z  M962.9,2088.8h372.6v-626c0-33.5,2.4-67,12.3-90.9c26.9-67,88.2-136.3,191.2-136.3c134.8,0,188.7,102.8,188.7,253.5v599.6h372.6 V1446c0-344.3-183.8-504.5-428.9-504.5c-201,0-289.2,112.3-338.3,188.8h2.5V967.8H962.9C967.8,1073,962.9,2088.8,962.9,2088.8 L962.9,2088.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.327ccd5781675740a2eae3369c5e9a42.svg";
export { ForwardRef as ReactComponent };